import React from 'react';
import { BrowserRouter } from 'react-router-dom';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { CookiesProvider } from "react-cookie"

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  /*  strictmode is only for test bugs. it render twice allmost everything
      so Im not using it.*/
      /*
  <React.StrictMode>
    <BrowserRouter basename='/'>
      <App />
    </BrowserRouter>
    
  </React.StrictMode>
  */
 /* https://upmostly.com/tutorials/cookies-in-reactjs-application */

  <CookiesProvider>
    <BrowserRouter basename='/'>
        <App />
    </BrowserRouter>
  </CookiesProvider>

);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();

